import { StyledBodyCell, StyledHeadCell, StyledTable } from 'baseui/table-grid'
import useRowsNestedRequestDetailsTable from './useRowsNestedRequestDetailsTable'

const RowsNestedRequestDetailsTable = ({ isSentRequest, requestResponse, requestUrl }) => {
  const { t, css, formatResponse } = useRowsNestedRequestDetailsTable({ isSentRequest, requestResponse })

  return (
    <div
      className={css({
        gridColumn: 'span 5',
        paddingTop: '5px',
        paddingBottom: '5px',
      })}
    >
      <StyledTable role='grid' $gridTemplateColumns={isSentRequest ? 'auto auto' : 'auto'}>
        <div role='row' className={css({ display: 'contents' })}>
          {isSentRequest && (
            <StyledHeadCell className={css({ backgroundColor: '#88EBB7' })}>
              {t('subscriptionForm:subscription_actions_module.export_logs.url_called_text')}
            </StyledHeadCell>
          )}
          <StyledHeadCell className={css({ backgroundColor: '#88EBB7' })}>
            {t('subscriptionForm:subscription_actions_module.export_logs.parameters_called_text')}
          </StyledHeadCell>
        </div>
        {isSentRequest && (
          <div role='row' className={css({ display: 'contents' })}>
            <StyledBodyCell>{requestUrl}</StyledBodyCell>
          </div>
        )}

        <div role='row' className={css({ display: 'contents' })}>
          <StyledBodyCell>
            <pre>{formatResponse()}</pre>
          </StyledBodyCell>
        </div>
      </StyledTable>
    </div>
  )
}

export default RowsNestedRequestDetailsTable
